import React from 'react';
import IntakeStartScreen from 'components/common/intakeStartScreen';
import NoPodiatryApp from 'components/nonPodiatry';

function ReasonForVisit() {
  return (
    <IntakeStartScreen
      currentStep="hpi"
      metaTitle="Reason for visit"
    >
      <NoPodiatryApp />
    </IntakeStartScreen>
  );
}

export default ReasonForVisit;
